import { queryString } from '@shared/hooks/recoil-query';
import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import {
  GiftRebateSettlement,
  GiftRebateSettleBody,
  GiftRebateSettleResult,
  GiftRebateSettlementPatchBody,
} from './giftRebateSettlement.interface';

// GiftAgent 유저는 /gift-seller 포털 진입 후 giftBrandRole()이 LowerRole.Admin을 반환하므로
// 백엔드 prefix는 /admin을 사용한다. LowerRole.GiftAgent는 이 API에서 쓰이지 않는다.
export type GiftRebateSettlementRole = LowerRole.Admin | LowerRole.BugoAgencyAdmin;

// ===== 조회 =====

export const listGiftRebateSettlements = async (
  filter: Record<string, unknown> = {},
  populate: unknown[] = [],
  options: Record<string, unknown> = { sort: { year: -1, month: -1 } },
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<GiftRebateSettlement[]> => {
  const { data } = await api_.get<GiftRebateSettlement[]>(
    `/${role}/gift-rebate-settlement?${queryString({ filter, populate, options })}`,
  );
  return data;
};

export const getGiftRebateSettlementById = async (
  id: string,
  populate: unknown[] = [],
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<GiftRebateSettlement> => {
  const { data } = await api_.get<GiftRebateSettlement>(
    `/${role}/gift-rebate-settlement/${id}?${queryString({ populate })}`,
  );
  return data;
};

export const countGiftRebateSettlements = async (
  filter: Record<string, unknown> = {},
  role: GiftRebateSettlementRole = LowerRole.Admin,
): Promise<number> => {
  const { data } = await api_.get<number>(
    `/${role}/gift-rebate-settlement/count?${queryString({ filter })}`,
  );
  return data;
};

// ===== 집행 (Admin 전용) =====

export const settleGiftRebate = async (
  body: GiftRebateSettleBody,
): Promise<GiftRebateSettleResult> => {
  const { data } = await api_.post<GiftRebateSettleResult>(
    `/${LowerRole.Admin}/gift-rebate-settlement/settle`,
    body,
  );
  return data;
};

// ===== 수정 (Admin 전용) =====

export const patchGiftRebateSettlement = async (
  id: string,
  body: GiftRebateSettlementPatchBody,
): Promise<GiftRebateSettlement> => {
  const { data } = await api_.patch<GiftRebateSettlement>(
    `/${LowerRole.Admin}/gift-rebate-settlement/${id}`,
    body,
  );
  return data;
};

// ===== 삭제 (Admin 전용) =====

export const deleteGiftRebateSettlement = async (id: string): Promise<void> => {
  await api_.delete(`/${LowerRole.Admin}/gift-rebate-settlement/${id}`);
};
